import { render, staticRenderFns } from "./MarkdownSelector.vue?vue&type=template&id=4965672a&"
import script from "./MarkdownSelector.vue?vue&type=script&lang=js&"
export * from "./MarkdownSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports